import { render, staticRenderFns } from "./RadioButtons.vue?vue&type=template&id=13c2554e&lang=pug&"
import script from "./RadioButtons.vue?vue&type=script&lang=ts&"
export * from "./RadioButtons.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports